import { UserModel } from '@admin/modules/users/models/user.model';

export const mapApiResponseToUsersModels = (response: any[]): UserModel[] => {
    return response.map((user: any) => {
        return {
            ...user,
            permissions: user.extraPermissions.length > 0 //TODO: to be changed
        };
    });
};
